/**
 * @generated SignedSource<<0029a71db40a948fb3ab74f841092485>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TabMenu_container$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HideItem_container" | "MoveItem_container" | "SetAsDefaultItem_container">;
  readonly " $fragmentType": "TabMenu_container";
};
export type TabMenu_container$key = {
  readonly " $data"?: TabMenu_container$data;
  readonly " $fragmentSpreads": FragmentRefs<"TabMenu_container">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "TabMenu_container",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SetAsDefaultItem_container"
    },
    {
      "kind": "FragmentSpread",
      "name": "MoveItem_container"
    },
    {
      "kind": "FragmentSpread",
      "name": "HideItem_container"
    }
  ],
  "type": "JiraContainerNavigationResult",
  "abstractKey": "__isJiraContainerNavigationResult"
};

(node as any).hash = "625543c1eef703b320bff9684648acce";

export default node;
